<template>
  <transition name="fade">
    <div class="c-header-menu-desktop" v-show="isShow">
      <div
        class="c-header-menu-desktop__container js-ignore-click-event"
        :style="position"
        @mouseleave="$emit('mouseleave')"
      >
        <div
          v-for="(column, index) in menuItems"
          class="c-header-menu-desktop__column"
          :key="index"
        >
          <template v-for="item in column" :key="item.url">
            <h2 class="c-header-menu-desktop__menu-title">
              <i
                :class="['c-header-menu-desktop__menu-icon', item.iconName]"
              ></i
              >{{ item.title }}
            </h2>
            <ul class="c-header-menu-desktop__menu-items">
              <li v-for="item in item.items" :key="item.url">
                <menu-item-desktop
                  :menu-item="item"
                  :show-image="index === 0"
                ></menu-item-desktop>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import MenuItemDesktop from '~/js/components/header/menuItemDesktop'

export default {
  name: 'ComponentHeaderMenuDesktop',
  components: { MenuItemDesktop },
  props: {
    isShow: { type: Boolean, default: false },
    menuItems: { type: Array, default: () => [] },
    position: {
      type: Object,
      default: () => {
        return {
          top: 0,
          right: 0,
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-menu-desktop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(#fff, 0.8);
  cursor: default;
  transition: 0.3s;

  &.fade-enter-from,
  &.fade-leave-to {
    opacity: 0;
  }

  &__container {
    align-items: flex-start;
    border-radius: 20px;
    box-shadow: 0px 0px 2px 2px rgba(#ababab, 0.25);
    background-color: #fff;
    display: flex;
    max-width: 100%;
    max-width: variables.$shell-max-width + variables.$shell-gutter * 2;
    overflow-y: scroll;
    position: fixed;
    padding: 48px 8px;
    z-index: variables.$z-index-header + 2;
  }

  &__column {
    min-width: 280px;
    max-width: 340px;
    padding: 0 40px;

    &:not(:last-child) {
      border-right: 1px solid variables.$color-gray;
    }
  }

  &__menu-icon {
    font-size: 22px;
    margin-right: 4px;
  }

  &__menu-title {
    font-size: 16px;
    font-weight: 600;
    padding: 8px 0;
  }

  &__menu-items {
    padding: 0 0 32px 28px;
  }
}
</style>
